module.exports = __webpack_public_path__ + "static/img/icon_crjb.0cda5a3c.png";